/**
 * This is a pure component for displaying the list of punche records.
 */
import React, { memo, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Checkbox } from "@material-ui/core";
import { createReviewData,filterEditablePunches } from "./utils";
import DayItem from "./DayItem";
import { useTranslation } from "react-i18next";
import { PENDING_I18N } from "config/CONSTANTS";
import { properCase } from "../../../../utils";
import { getDurationInHours } from "utils";

const useStyles = makeStyles({
  root: {},
});

/**
 * Component to render tabular format for all the review of all punch record.
 * This will display nested datagrid for day-wise records.
 * Each day will further expand to show punch records of that day.
 * Each day will be selectable for approval.
 * @param {object} props will have all punch records and start-date of the selected week, worker details
 */
export const SelectPunch = (props) => {
  const { setTotalHours, setMealHours } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  // const [selected, setSelected] = React.useState([]); // Date collection
  const [selected, setSelected] = props.useSelectedState; // Date collection
  const [selectedPunches, setSelectedPunches] = props.useSelectedPunchsState; // punch record collection
  let hours = 0;
  let mhours = 0;

  const handleSelectAllClick = (event) => {
    event.stopPropagation();
    if (event.target.checked) {
      const newSelecteds = pendingApproval.map((n) => n.id);
      setSelected(newSelecteds);
      let newSelectedPunches = [];
      pendingApproval.map((n) => {
        n.punches.map((p) => newSelectedPunches.push(p.id));
      });
      setSelectedPunches(newSelectedPunches);
      return;
    }
    setSelected([]);
    setSelectedPunches([]);
    console.log("SelectPunch: selectedPunches", selectedPunches);
  };
  const handleSelect = (event, dateRow) => {
    event.stopPropagation();
    const selectedIndex = selected.indexOf(dateRow.id);
    let newSelected = [];
    let newSelectedPunches = [];
    const datePunchIds = dateRow.punches.map((n) => n.id);
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, dateRow.id);
      newSelectedPunches = newSelectedPunches.concat(
        selectedPunches,
        datePunchIds
      );
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelectedPunches = newSelectedPunches.concat(
        selectedPunches.filter((f) => !datePunchIds.includes(f))
      );
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelectedPunches = newSelectedPunches.concat(
        selectedPunches.filter((f) => !datePunchIds.includes(f))
      );
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
      newSelectedPunches = newSelectedPunches.concat(
        selectedPunches.filter((f) => !datePunchIds.includes(f))
      );
    }
    setSelected(newSelected);
    setSelectedPunches(newSelectedPunches);
    console.log("SelectPunch: selectedPunches", newSelectedPunches);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  let rows = [];
  if (
    props.punchesData &&
    props.punchesData.data &&
    props.punchesData.data.length > 0
  ) {
    let rowsData = createReviewData(props.punchesData.data, props.startDate);
    rows = filterEditablePunches(rowsData);
  }

  const pendingApproval = rows.filter(
    (row) =>
      !row.isApproved &&
      row.durationInHrs &&
      // t(row.status) === PENDING
      row.status === PENDING_I18N
  );

  useEffect(() => {
    rows.forEach((element) => {
      hours += parseFloat(element.durationInHrs);
    });

    setTotalHours(hours.toFixed(2));
  }, [rows]);

  //for meal calculation
  useEffect(() => {
    if (props.punchesData.data != undefined)
      props.punchesData.data.forEach((item) => {
        if (item.activityGroup == "Meal") {
          mhours += parseFloat(getDurationInHours(item));
        }
      });
    setMealHours(mhours.toFixed(2));
  }, [rows]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={
                  selected.length > 0 &&
                  selected.length < pendingApproval.length
                }
                checked={
                  pendingApproval.length > 0 &&
                  selected.length === pendingApproval.length
                }
                onChange={handleSelectAllClick}
                inputProps={{ "aria-label": "select all" }}
              />
            </TableCell>

            <TableCell>{properCase(t("pgReview.tableHeads.hours"))}</TableCell>
            <TableCell>{properCase(t("pgReview.tableHeads.day"))}</TableCell>
            <TableCell align="right">
              {properCase(t("pgReview.tableHeads.status"))}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <DayItem
              key={row.id}
              worker={props.worker}
              row={row}
              isItemSelected={isSelected(row.id)}
              handleClick={handleSelect}
              labelId={`enhanced-table-checkbox-${index}`}
              deleteHandler={props.deleteHandler}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SelectPunch.propTypes = {
  punchesData: PropTypes.object.isRequired,
  useSelectedPunchsState: PropTypes.array.isRequired,
  startDate: PropTypes.any,
  worker: PropTypes.object,
};

export default memo(SelectPunch);
